import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { decryptData, OpenSwal, GoogleMapNavigation, notistackSnakebar } from '../../Utils';
import { ScrollTypography, GreenSwitch } from '../../Styles';
import { Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import AssignmentNewRequestList from '../../Components/Interpreter/AssignmentNewRequestList';
import { IconParkTwotoneMapDistance } from '../../SvgIcons/SvgIcons';
import LinearProgress from '@mui/material/LinearProgress';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import AssignmentAcceptComp from '../../Components/Interpreter/AssignmentAcceptComp';
import AssignmentAfterAcceptComp from '../../Components/Interpreter/AssignmentAfterAcceptComp';
import AssignmentAfterGetStarted from '../../Components/Interpreter/AssignmentAfterGetStarted';
import AssignmentRejectComp from '../../Components/Interpreter/AssignmentRejectComp';
import AssignmentEndPage1 from '../../Components/Interpreter/AssignmentEndPage1';
import AssignmentViewBilling from '../../Components/Interpreter/AssignmentViewBilling';
import AssignmentCancelComp from '../../Components/Interpreter/AssignmentCancelComp';
import AssignmentAfterCancelled from '../../Components/Interpreter/AssignmentAfterCancelled';
import { FormControlLabel } from '@mui/material';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import QRCode from "react-qr-code";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSnackbar } from 'notistack';
import { url_fetch_assignment_confirmation_detail } from '../../RoutesMap';
import Skeleton from '@mui/material/Skeleton';
import dayjs from 'dayjs';
import { apiWithAuth } from '../../Services/Axios/axios';




export default function AssignmentAcceptPage({ PusherDashboardTrigger }) {
    const get_params = useParams();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const { assignid, pagestatus } = useParams();

    const assign_id = get_params.assignid;
    let current_pagestatus = "";
    let current_cancel_id = "";
    // if (get_params.pagestatus) {
    //     current_pagestatus = decryptData(decodeURIComponent(get_params.pagestatus));
    // }
    if (get_params.pagestatus) {
        if (get_params.pagestatus === "verification") {
            current_pagestatus = "verification";
        } else {
            current_pagestatus = decryptData(
                decodeURIComponent(get_params.pagestatus)
            );
        }
    }
    const isVerification = current_pagestatus === "verification";

    if (get_params.cancel_id) {
        current_cancel_id = get_params.cancel_id;
    }

    let support_tel_number = process.env.REACT_APP_ASSIGN_ACCEPT_SUPPORT_CALL_NUMBER;
    const [AssignmentCustomerPromtBeforeAcceptAry, AssignmentCustomerPromtBeforeAcceptArySet] = useState([]);
    const [AssignmentCustomerPromtAfterAcceptAry, AssignmentCustomerPromtAfterAcceptArySet] = useState([]);
    const [AssignmentCancelReasonsAry, AssignmentCancelReasonsArySet] = useState([]);
    const [AssignmentCancelReasonCancellationCode, AssignmentCancelReasonCancellationCodeSet] = useState('');
    const [AssignmentCustomerPromtAfterAcceptConsumerServName, AssignmentCustomerPromtAfterAcceptConsumerServNameSet] = useState([]);
    const minWidth300 = useMediaQuery('(width<=300px)');

    const navigate = useNavigate();
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
    let defaultHeaderCardValues = {
        assign_miles: 0,
        // callnumber: 0,
        assign_orderid: null,
        assign_requestdatetime: null,
    }
    // const [newAssignmentRequestAry, newAssignmentRequestArySet] = useState([]);
    const [AssignmentDetailsAry, AssignmentDetailsArySet] = useState(defaultHeaderCardValues);
    const [AssignmentDetailsAryAll, AssignmentDetailsAryAllSet] = useState({});
    const [AssignmentCurrentStatus, AssignmentCurrentStatusSet] = useState('');
    const [AssignmentCurrentPostStatus, AssignmentCurrentPostStatusSet] = useState('');
    const [AssignmentStartdateTime, AssignmentStartdateTimeSet] = useState({});
    const [AssignmentCancelReasonSelectShow, AssignmentCancelReasonSelectShowSet] = useState('');
    const [AssignmentEndPageDetails, AssignmentEndPageDetailsSet] = useState({ assign_endtime: '', checkout_type: '', paperwork_path: '', assign_startime: '' });
    const [assignmentTimeValidationError, assignmentTimeValidationErrorSet] = useState(false);
    const Apply_local_time_statelocalstorage = localStorage.getItem('Apply_local_time_state');

    const [ApplyLocalTimeState, ApplyLocalTimeStateSet] = useState((Apply_local_time_statelocalstorage) ? true : false);
    const [AssignmentHeadingPageName, AssignmentHeadingPageNameSet] = useState('Assignment Detail');
    const [DialogBoxStatus, DialogBoxStatusSet] = useState(false);
    const [URLThirdSegmentName, URLThirdSegmentNameSet] = useState('');
    const [CardBackgroudColorValue, CardBackgroudColorValueSet] = useState('#fff');
    const [CardInsideCardBackgroudColorValue, CardInsideCardBackgroudColorValueSet] = useState(appThemeColor);


    function changeAssignmentCurrentStatus(status) {
        AssignmentCurrentStatusSet(status);
    }
    function changeAssignmentPostCurrentStatus(status) {
        AssignmentCurrentPostStatusSet(status);
    }

    let get_thirdsegment = window.location.pathname.split('/')[2];

    useEffect(() => {

        URLThirdSegmentNameSet(get_thirdsegment);
        if (((AssignmentCurrentStatus === "Accepted" && (AssignmentCurrentPostStatus === "Check In" || AssignmentCurrentPostStatus === "Lapsed")) || (AssignmentCurrentStatus === "Completed" && !isVerification)) && URLThirdSegmentName === "Assignment_Acceptence") {
            CardBackgroudColorValueSet('#E9FEAB');
            CardInsideCardBackgroudColorValueSet(appThemeColor);
        } else if (AssignmentCurrentStatus === "Completed" && URLThirdSegmentName === "Assignment_DetailPage") {
            CardBackgroudColorValueSet('#E5FAF9');
            CardInsideCardBackgroudColorValueSet('#009F96');
        } else if (AssignmentCurrentStatus === "CancelEnd") {
            CardBackgroudColorValueSet('#fff');
            CardInsideCardBackgroudColorValueSet('#eb5757');
        } else {
            CardBackgroudColorValueSet('#fff');
            CardInsideCardBackgroudColorValueSet(appThemeColor);
        }

    }, [AssignmentCurrentStatus, AssignmentCurrentPostStatus]);
    useEffect(() => {
        AssignmentCurrentStatusSet('');
        AssignmentDetailsArySet(defaultHeaderCardValues);
        let assign_data = { assignid: assign_id, page_status: current_pagestatus, localtime: ApplyLocalTimeState, cancel_id: current_cancel_id }
        apiWithAuth.post(url_fetch_assignment_confirmation_detail, assign_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                AssignmentDetailsArySet({
                    assign_miles: response.data.data.assign_miles,
                    assign_orderid: response.data.data.assign_orderid,
                    assign_requestdatetime: response.data.data.assign_requestdatetime,
                });
                if (response.data.data.assign_status === "Completed") {
                    AssignmentEndPageDetailsSet({ assign_endtime: response.data.data.assign_end_time, checkout_type: response.data.data.assign_checkout_type, paperwork_path: response.data.data.assign_paper_work_url, assign_startime: response.data.data.assign_start_time_value });
                }
                AssignmentStartdateTimeSet(response.data.data.assign_start_time);
                AssignmentDetailsAryAllSet(response.data.data);
                if (get_thirdsegment === "Assignment_DetailPage" && current_pagestatus === "Cancelled_list") {
                    AssignmentCurrentStatusSet("CancelEnd");
                    AssignmentCurrentPostStatusSet("");
                } else {
                    AssignmentCurrentStatusSet(response.data.data.assign_status);
                    AssignmentCurrentPostStatusSet(response.data.data.assign_post_status);
                }
                AssignmentCancelReasonSelectShowSet(response.data.data.assign_cancel_reason);
                if(response.data.data.cancellation_code) {
                    const label = Object.values(response.data.data.cancellation_code)[0];
                    AssignmentCancelReasonCancellationCodeSet(label);
                }

                AssignmentCustomerPromtBeforeAcceptArySet(response.data.data.customer_promt_before_accept);
                AssignmentCustomerPromtAfterAcceptArySet(response.data.data.customer_promt_after_accept);
                AssignmentCustomerPromtAfterAcceptConsumerServNameSet(response.data.data.assign_consumer_service_name);
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else OpenSwal('Axios_error', response.data.message);

        }).catch(response => OpenSwal('Axios_error', response.message));


    }, [assign_id]);


    const triggerLocalTime = (localtime_status) => {
        let assign_data = { assignid: assign_id, page_status: current_pagestatus, localtime: localtime_status, cancel_id: current_cancel_id }

        apiWithAuth.post(url_fetch_assignment_confirmation_detail, assign_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                AssignmentDetailsArySet({
                    assign_miles: response.data.data.assign_miles,
                    assign_orderid: response.data.data.assign_orderid,
                    assign_requestdatetime: response.data.data.assign_requestdatetime,
                });
                if (response.data.data.assign_status === "Accepted") {
                    AssignmentEndPageDetailsSet({ ...AssignmentEndPageDetails, assign_endtime: response.data.data.assign_end_time, assign_startime: response.data.data.assign_start_time_value });
                } else if (response.data.data.assign_status === "Completed") {
                    AssignmentEndPageDetailsSet({ assign_endtime: response.data.data.assign_end_time, checkout_type: response.data.data.assign_checkout_type, paperwork_path: response.data.data.assign_paper_work_url, assign_startime: response.data.data.assign_start_time_value });
                }
                AssignmentStartdateTimeSet(response.data.data.assign_start_time);
                AssignmentDetailsAryAllSet(response.data.data);

            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else OpenSwal('Axios_error', response.data.message);
        }).catch(response => OpenSwal('Axios_error', response.message));
    }

    const ApplyLocalTimeStateSwitch = async (element) => {
        if (element.target.checked) localStorage.setItem('Apply_local_time_state', true);
        else localStorage.removeItem('Apply_local_time_state');

        ApplyLocalTimeStateSet(element.target.checked);
        // console.log(element.target.checked)
        triggerLocalTime(element.target.checked);
    }
    // console.log(AssignmentDetailsAry.service_type)
    const navigateGoogleMap = () => {
        if (!navigator.geolocation) {
            notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Geolocation is Not Supported in your browser", variant: 'error' });
        } else {
            navigator.geolocation.getCurrentPosition(function (position) {
                GoogleMapNavigation({ latitude: position.coords.latitude, longitude: position.coords.longitude, address: AssignmentDetailsAryAll.assign_location });
            }, function (error) {
                if (error.code === 1) {
                    notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Please turn on the location Permission", variant: 'error' });
                } else {
                    notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: error.message, variant: 'error' });
                }
            });
        }
    }
    // const GoBackList = () => {
    //     if (current_pagestatus !== "") {
    //         navigate('/Interpreter/' + current_pagestatus);
    //     } else if (current_pagestatus === "") {
    //         navigate('/Interpreter/Dashboard');
    //     }
    // }

    const GoBackList = () => {
        if (current_pagestatus === "Lapsed_list" || current_pagestatus === "verification") {
            navigate('/Interpreter/action_list');
        } else if (current_pagestatus !== "") {
            navigate('/Interpreter/' + current_pagestatus);
        } else if (current_pagestatus === "") {
            navigate('/Interpreter/Dashboard');
        }
    }
    return (
        <Box >

            {/* <Box>
                <Dialog open={DialogBoxStatus} onClose={() => DialogBoxStatusSet(false)}  >
                    <DialogTitle color={appThemeColor} fontWeight='bold' variant='subtitle1'> QR Code for {AssignmentDetailsAry.assign_orderid}</DialogTitle>
                    <DialogContent>
                        <Box sx={{ margin: "0 auto", maxWidth: { xs: 250, sm: 300, md: 600 }, width: '100%' }}>
                            {AssignmentDetailsAryAll.assign_qrcode_int && <QRCode
                                size={256}
                                style={{ height: "100%", width: "100%" }}
                                value={AssignmentDetailsAryAll.assign_qrcode_int}

                            />}
                        </Box>
                    </DialogContent>
                    <DialogActions>

                        <Button sx={{ mt: -2, textTransform: 'none' }} color={appThemeSecondaryColor} onClick={() => DialogBoxStatusSet(false)} size='small' startIcon={<CloseIcon />} >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

            </Box> */}
            {(AssignmentCurrentStatus === "In Progress" || AssignmentCurrentStatus === "" || AssignmentCurrentStatus === "Accepted" || AssignmentCurrentStatus === "Lapsed" || AssignmentCurrentStatus === "CancelStart" || AssignmentCurrentStatus === "Completed" || AssignmentCurrentStatus === "CancelEnd") && <Box >
                <Grid container spacing={1}>
                    <Grid xs={10} sm={10} md={10}>
                        <Box >
                            {((AssignmentCurrentStatus === "" || AssignmentCurrentStatus === "Accepted" || AssignmentCurrentStatus === "Lapsed") && (AssignmentCurrentPostStatus === "" || AssignmentCurrentPostStatus === "Started" || AssignmentCurrentPostStatus === "Arrived")) && <Box> <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }} >Assignment Detail</Typography> </Box>}
                            {AssignmentCurrentStatus === "In Progress" && <Box> <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }} >Accept Assignment</Typography> </Box>}
                            {(AssignmentCurrentStatus === "Accepted" && AssignmentCurrentPostStatus === "Check In") && <Box> <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }} >Assignment - In Progress</Typography> </Box>}
                            {((AssignmentCurrentStatus === "Accepted" || AssignmentCurrentStatus === "Lapsed") && AssignmentCurrentPostStatus === "Lapsed") && <Box> <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }} >Service Information Completion</Typography> </Box>}
                            {(AssignmentCurrentStatus === "Completed") && <Box> <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }} >{(URLThirdSegmentName === "Assignment_Acceptence") ? AssignmentHeadingPageName : "Billing Summary"}</Typography> </Box>}
                            {(AssignmentCurrentStatus === "CancelStart") && <Box> <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }} >Cancelled Assignment</Typography> </Box>}
                            {(AssignmentCurrentStatus === "CancelEnd") && <Box> <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }} >Cancelled Assignment</Typography> </Box>}
                        </Box>
                    </Grid>
                    <Grid xs={2} sm={2} md={2}>

                        <Box sx={{ display: 'flex', justifyContent: 'right' }}>
                            <Button startIcon={<ArrowBackIcon sx={{ mr: -1, fontSize: '2px' }} />} onClick={GoBackList} sx={{ textDecoration: 'underline', textTransform: 'none', color: appThemeColor }} >Back</Button>
                        </Box>
                    </Grid>

                </Grid>

                <Box sx={{ mt: { xs: 0, sm: 0, md: 2 } }}>
                    <Grid container spacing={1}  >
                        <Grid xs={5} sm={5} md={5}>
                            <Box sx={{ position: 'absolute', top: { xs: '120px', sm: '120px', md: '140px' }, left: '30px' }} >
                                <Card sx={{ backgroundColor: CardInsideCardBackgroudColorValue, borderRadius: 5, boxShadow: '#fff 0px 0px 5px', height: 'auto', width: { xs: '105px', sm: '125px' } }}>
                                    <CardContent sx={{ padding: { xs: '8px', sm: '9px', md: '12px' } }}>
                                        {AssignmentDetailsAry.assign_requestdatetime ? <Typography color="#fff" sx={{ whiteSpace: 'nowrap', typography: { xs: 'caption', sm: 'body2', md: 'body2' } }}>{dayjs(AssignmentDetailsAry.assign_requestdatetime).format("dddd")}</Typography> : <Skeleton animation="wave" />}
                                        {(AssignmentDetailsAry.assign_requestdatetime) ? <Typography variant="h5" color="#fff" sx={{ mb: -1 }} >{(new Date(AssignmentDetailsAry.assign_requestdatetime).getDate() <= 9) ? dayjs(AssignmentDetailsAry.assign_requestdatetime).format('[0]Do') : dayjs(AssignmentDetailsAry.assign_requestdatetime).format('Do')}</Typography> : <Skeleton animation="wave" />}
                                        {(AssignmentDetailsAry.assign_requestdatetime) ? <Box sx={ScrollTypography}> <Typography color='#fff' sx={{ whiteSpace: 'nowrap', typography: { xs: 'subtitle2', sm: 'body2', md: 'subtitle1' } }}  >{dayjs(AssignmentDetailsAry.assign_requestdatetime).format("MMMM [']YY")}</Typography>
                                        </Box> : <Skeleton animation="wave" />}

                                        {(AssignmentDetailsAry.assign_requestdatetime) ? <Box sx={{ display: 'flex', alignItems: 'center', position: 'absolute', left: '7px' }}>
                                            <TimerOutlinedIcon sx={{ color: 'white', fontSize: { xs: '15px', sm: '16px', md: '20px' }, mr: 0.2 }} /> <Typography variant="caption" color='#fff' sx={{ whiteSpace: 'nowrap', letterSpacing: '-0.5px' }}  >{dayjs(AssignmentDetailsAry.assign_requestdatetime).format("hh:mm A")}</Typography>
                                        </Box> : <Skeleton animation="wave" />}

                                    </CardContent>
                                </Card>
                            </Box>
                        </Grid>
                        <Grid xs={7} sm={7} md={7}>
                            <Box >
                                <Grid container   >
                                    <Grid xs={6} sm={6} md={6} sx={{ height: '35px' }}>
                                        {(AssignmentDetailsAryAll.service_type === "InPerson Interpretation" && (AssignmentCurrentStatus === "In Progress" || AssignmentCurrentStatus === "Accepted" || AssignmentCurrentStatus === "Lapsed")) && <Button sx={{ color: appThemeColor, textTransform: 'none', letterSpacing: '-0.8px', whiteSpace: 'nowrap' }} onClick={navigateGoogleMap}><IconParkTwotoneMapDistance color='#4b4b4c' size='1.4em' /> &nbsp; {AssignmentDetailsAry.assign_miles} Miles </Button>}
                                    </Grid>
                                    <Grid xs={6} sm={6} md={6} >

                                        <Box sx={{ display: 'flex', justifyContent: 'right' }}>
                                            {(AssignmentCurrentStatus === "Accepted" || AssignmentCurrentStatus === "Lapsed" || AssignmentCurrentStatus === "Completed" || AssignmentCurrentStatus === "CancelStart") &&
                                                <Button component={Link} href={"tel:" + support_tel_number} sx={{ color: appThemeColor, textTransform: 'none', letterSpacing: '-1px', whiteSpace: 'nowrap' }}  ><CallOutlinedIcon sx={{ color: '#4b4b4c', fontSize: { xs: '15px', sm: '18px', md: '20px' } }} />&nbsp; Call ITI</Button>}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>

                        </Grid>
                    </Grid>

                    <Card sx={{ backgroundColor: CardBackgroudColorValue, height: 'auto', borderRadius: 1 }}>
                        <CardContent sx={{ padding: { xs: '6px', sm: '7px', md: '10px' }, position: 'relative' }} >
                            <Box >
                                <Box sx={{ position: 'absolute', mt: 0.1, left: { xs: '115px', sm: '135px' }, width: { xs: (minWidth300) ? 80 : 105, sm: 150, md: 400 } }} >
                                    {(AssignmentDetailsAry.assign_orderid) ? <Box sx={ScrollTypography}>
                                        <Typography sx={{ typography: { xs: 'subtitle1', sm: 'h5', md: 'h5' }, px: 1 }} color="#4b4b4c" style={{ fontWeight: 'bold' }}  >{AssignmentDetailsAry.assign_orderid}</Typography>
                                    </Box> : <Skeleton animation="wave" />}
                                </Box>
                                <FormControlLabel value="bottom" sx={{ position: 'absolute', top: -2, right: '-10px' }} control={<GreenSwitch onChange={(evt) => ApplyLocalTimeStateSwitch(evt)} checked={ApplyLocalTimeState} />} label={<Typography variant="caption" sx={{ letterSpacing: '-0.5px', whiteSpace: 'nowrap', position: 'absolute', top: '28px' }} color="#4b4b4c" > Local Time</Typography>} labelPlacement="bottom" />
                            </Box>
                            <Box sx={{ mt: 6 }}>
                                {AssignmentCurrentStatus === "" && <Box sx={{ mt: 10, mb: 5, display: 'flex', justifyContent: 'center' }}><LinearProgress color={appThemeSecondaryColor} sx={{ width: '70%', alignItems: 'center' }} /></Box>}
                                {AssignmentCurrentStatus === "In Progress" && <AssignmentAcceptComp AssignmentDetailsAry={AssignmentDetailsAryAll} AssignmentCustomerPromtBeforeAcceptAry={AssignmentCustomerPromtBeforeAcceptAry} changeAssignStatus={changeAssignmentCurrentStatus} assign_id={assign_id} />}
                                {((AssignmentCurrentStatus === "Accepted" || AssignmentCurrentStatus === "Lapsed") || AssignmentCurrentStatus === "CancelStart") && AssignmentCurrentPostStatus !== "Check In" && AssignmentCurrentPostStatus !== 'Lapsed' && <AssignmentAfterAcceptComp AssignmentDetailsAry={AssignmentDetailsAryAll} AssignmentDetailsAryAllSet={AssignmentDetailsAryAllSet} AssignmentStartdateTimeSet={AssignmentStartdateTimeSet}  AssignmentCustomerPromtAfterAcceptConsumerServName={AssignmentCustomerPromtAfterAcceptConsumerServName}AssignmentCustomerPromtAfterAcceptAry={AssignmentCustomerPromtAfterAcceptAry} changeAssignStatus={changeAssignmentCurrentStatus} changeAssignPostStatus={changeAssignmentPostCurrentStatus} AssignmentCancelReasonsArySet={AssignmentCancelReasonsArySet} assign_id={assign_id} DialogBoxStatusSet={DialogBoxStatusSet} />}
                                {(((AssignmentCurrentStatus === "Accepted" || AssignmentCurrentStatus === "Lapsed" )&& (AssignmentCurrentPostStatus === "Check In" || AssignmentCurrentPostStatus === 'Lapsed')) || (AssignmentCurrentStatus === "Completed")) && <AssignmentAfterGetStarted assign_id={assign_id} AssignmentDetailsAry={AssignmentDetailsAryAll} AssignmentStartdateTime={AssignmentStartdateTime} AssignmentEndPageDetails={AssignmentEndPageDetails} AssignmentEndPageDetailsSet={AssignmentEndPageDetailsSet} onTimeValidationChange={assignmentTimeValidationErrorSet} DialogBoxStatusSet={DialogBoxStatusSet} URLThirdSegmentName={URLThirdSegmentName} />} 
                                {(AssignmentCurrentStatus === "CancelEnd") && <AssignmentAfterCancelled AssignmentDetailsAry={AssignmentDetailsAryAll} />}
                            </Box>
                        </CardContent>
                    </Card>
                </Box></Box>}
            {AssignmentCurrentStatus === "No_Access" && <AssignmentRejectComp AssignmentDetailsAry={AssignmentDetailsAryAll} status="No_Access" AssignmentCancelReasonSelectShow={AssignmentCancelReasonCancellationCode} />}
            {/* Reject Top Card */}
            {AssignmentCurrentStatus === "Rejected" && <AssignmentRejectComp AssignmentDetailsAry={AssignmentDetailsAryAll} status="Rejected" AssignmentCancelReasonSelectShow={AssignmentCancelReasonCancellationCode} />}

            {/* Empty Comp */}
            {AssignmentCurrentStatus === "" && <Box sx={{ mt: 5, mb: 5 }} ></Box>}

            {/* New Request Cards */}

            {/* End Assignment bottom1 */}
            {((AssignmentCurrentStatus === "Accepted" || AssignmentCurrentStatus === "Lapsed") && (AssignmentCurrentPostStatus === "Check In" || AssignmentCurrentPostStatus === "Lapsed")|| (AssignmentCurrentStatus === "Completed" && isVerification)) && <AssignmentEndPage1 assign_id={assign_id} AssignmentStartdateTime={AssignmentStartdateTime} AssignmentDetailsAry={AssignmentDetailsAryAll} AssignmentDetailsAryAllSet={AssignmentDetailsAryAllSet} AssignmentEndPageDetailsSet={AssignmentEndPageDetailsSet} AssignmentEndPageDetails={AssignmentEndPageDetails} changeAssignStatus={changeAssignmentCurrentStatus} AssignmentCurrentPostStatus={AssignmentCurrentPostStatus} AssignmentCancelReasonCancellationCode={AssignmentCancelReasonCancellationCode} isVerificationPage={isVerification} pageStatus={pagestatus}/>}
            {(AssignmentCurrentStatus === "Completed" && !isVerification) && <AssignmentViewBilling assign_id={assign_id} AssignmentDetailsAry={AssignmentDetailsAryAll} AssignmentHeadingPageNameSet={AssignmentHeadingPageNameSet} URLThirdSegmentName={URLThirdSegmentName} />}



            {/* Cancel Card */}
            {AssignmentCurrentStatus === "CancelStart" && <AssignmentCancelComp assign_id={assign_id} AssignmentCancelReasonsAry={AssignmentCancelReasonsAry} changeAssignStatus={changeAssignmentCurrentStatus} AssignmentCancelReasonSelectShowSet={AssignmentCancelReasonSelectShowSet} />}
            {AssignmentCurrentStatus === "CancelEnd" && <AssignmentRejectComp AssignmentDetailsAry={AssignmentDetailsAryAll} status="Cancelled" AssignmentCancelReasonSelectShow={AssignmentCancelReasonSelectShow} AssignmentCancelReasonCancellationCode={AssignmentCancelReasonCancellationCode} />}
            {((AssignmentCurrentStatus === "In Progress" || AssignmentCurrentStatus === "Accepted" || AssignmentCurrentStatus === "Lapsed" || AssignmentCurrentStatus === "Rejected" || AssignmentCurrentStatus === "CancelEnd") && AssignmentCurrentPostStatus !== "Check In" && AssignmentCurrentPostStatus !== 'Lapsed') && <AssignmentNewRequestList assign_id={assign_id} PusherDashboardTrigger={PusherDashboardTrigger} />}
        </Box >





    );
}